import { InjectionToken } from '@angular/core';

export const FEATURE_NAME = '@vshosting/cdn/core/user-base';

export const API_CLIENT_ZONE_URL = new InjectionToken<string>('@vshosting/cdn/core/user-base/API_CLIENT_ZONE_URL');
